<template>
    <section class="product-content">        
        <slot>
            <router-link :to="`/${product.slug}`">
                <figure>
                    <img :src="uri" />
                    <figcaption v-text="product.title" />
                </figure>
            </router-link>
        </slot>
	</section> 
</template>

<script>
import { filesComputed } from '@/features/files/store'
export default {
    props: {
        slug: {
            type: String
        },
        product: {
            type: [Boolean,Object],
            required: false,
            default: () => (false)
        }
    },
    computed: {
        ...filesComputed,
        uri(){
            if (!this.product) return false
            let test = this.product.files
            if (test.length == 0)
                return 'No Image Found'
            return test[0].uri
        }
    }
}
</script>